import * as React from "react";
import { Component } from "react";
import { Field, Form, getFormValues, reduxForm } from "redux-form";
import styles from "../../../styles/forms/superadmin/add_boq_template_subgroup_wizard/AddBOQTemplateSubgroupForm.scss";
import Button from "../../../components/Button";
import Select from "../../../components/Select";
import Input from "../../../components/Input";
import { __, mapStateToProps, setTableParams, getLocalized } from "../../../core/utils";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import ButtonGroup from "../../../components/ButtonGroup";
import { subscribe } from "react-contextual";
import Localization from "../../../helpers/Localization";
import {listLocalization} from "../../../redux/actions/localization";

@withRouter
@reduxForm({ form: "superadmin.add_boq_template_subgroup_wizard.add_boq_template_subgroup" })
@subscribe(Localization, "localization")
@mapStateToProps(state => ({
    values: getFormValues("superadmin.add_boq_template_subgroup_wizard.add_boq_template_subgroup")(state),
    application_language_id: state.auth.language_id
}))
class AddBOQTemplateSubgroupForm extends Component {
    @autobind
    _handleSubmit(edit) {
        this.props.change('edit', edit);

        setTimeout(() => this.props.submit(), 10);
    }

    componentDidMount() {
        listLocalization();
    }

    render() {
        const application_languages = _.transform(_.filter(this.props.localization.languages, language => language.application_language == true), (languages, language) => {
            languages[language.id] = language.id == this.props.application_language_id;

            return languages;
        }, {});

        const boq_template_groups = _.map(this.props.localization.boq_template_groups, item => ({
			value: item.id,
			label: getLocalized(item.name, this.props.application_language_id),
        }));

        return (
            <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
                <div className={styles.form}>
                    <Field name="name" localized={application_languages} component={Input} label="Name" />
                    <Field name="boq_template_group_id" component={Select} searchable options={boq_template_groups} label="BOQ Template Group" />
                </div>
                <div className={styles.footer}>
                    <Button lightGray medium left middleText={__('button.cancel')} onClick={() => setTableParams('superadmin_boq_template_subgroups', {
                        add_boq_template_subgroup_wizard: undefined
                    })} />
                    <ButtonGroup>
                        <Button lightBlue medium middleText={__('button.create')} spinning={this.props.submitting} onClick={() => this._handleSubmit(false)} />
                        <Button lightBlue medium middleText={__('button.create-edit')} spinning={this.props.submitting} onClick={() => this._handleSubmit(true)} />
                    </ButtonGroup>
                </div>
            </Form>
        );
    }
}

export default AddBOQTemplateSubgroupForm;
